// extracted by mini-css-extract-plugin
export default {"content":"ChipCell-module__content__s2p5Y"};